/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { COMMON, HOME_TODAY_SCREEN, PERMISSION_CONSTANTS } from '../../global/Constants'
import { ALL_ROUTES } from '../../global/Constants';
import { withRouter } from 'react-router-dom';
import AuthService from '../../providers/AuthService';
import SyncServices from '../../providers/SyncServices';
import Utilities from '../../global/Utilities';
import { toast } from 'react-toastify';
import ApiServices from '../../providers/ApiServices';

class Footer extends Component {

    componentDidMount() {
        const { isActive } = this.props;
        this._handleIsActive(isActive);
    }

    constructor(props) {
        super(props)
        this.state = {
            isDashboardActive: false,
            isTodayActive: false,
            isCalendarActive: false,
            isKrishakActive: false,
            isMoreMenuActive: false,
            mobileNumber: '',
        }
    }

    verifyNumber = event => {
        const { value, maxLength } = event.target;
        const mobileNumber = value.slice(0, maxLength);
        this.setState({ mobileNumber });
    }

    _handleIsActive = (isActive) => {
        switch (isActive) {
            case 0:
                this.setState({
                    isDashboardActive: true,
                    isCalendarActive: false,
                    isTodayActive: false,
                    isKrishakActive: false,
                    isMoreMenuActive: false,
                })
                break;
            case 1:
                this.setState({
                    isDashboardActive: false,
                    isCalendarActive: true,
                    isTodayActive: false,
                    isKrishakActive: false,
                    isMoreMenuActive: false,
                })
                break;
            case 2:
                this.setState({
                    isDashboardActive: false,
                    isCalendarActive: false,
                    isTodayActive: true,
                    isKrishakActive: false,
                    isMoreMenuActive: false,
                })
                break;
            case 3:
                this.setState({
                    isDashboardActive: false,
                    isCalendarActive: false,
                    isTodayActive: false,
                    isKrishakActive: true,
                    isMoreMenuActive: false,
                })
                break;
            case 4:
                this.setState({
                    isDashboardActive: false,
                    isCalendarActive: false,
                    isTodayActive: false,
                    isKrishakActive: false,
                    isMoreMenuActive: true,
                })
                break;
            default:
                break;
        }

    }

    _handleDashboardClick = () => {
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }
        this.props.history.push(ALL_ROUTES.DASHBOARD_ROUTE);
    }

    _handleTodayClick = () => {
        this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
    }

    _handleCalendarClick = () => {
        this.props.history.push(ALL_ROUTES.CALENDAR_ROUTE);
    }

    _handleKrishakClick = () => {
        SyncServices.findKrishakFromDatabase("key", this.state.mobileNumber).then(data => {
            if (data) {
                Utilities.LogPrint("getKrishakFromDatabase", data);
                if (Utilities.isNetworkConnected() && data.krishak_id > 0) {
                    this.getKrishakById(data.krishak_id);
                } else {
                    if (data.krishak_id === 0) {
                        this.goToKrishakPage(data);
                    } else {
                        toast.info(COMMON.OFFLINE_KRISHAK_EDIT_MESSAGE);
                    }
                }
            } else {
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
                    state: { mobileNumber: this.state.mobileNumber }
                });
            }
        });

        // var params = JSON.stringify({
        //     krishak_id: 0,
        //     phone: this.state.mobileNumber,
        // });
        // try {
        //     ApiServices.getKrishakByReferenceId(params)
        //         .then(response => {
        //             var status = response.success;
        //             if (status) {
        //                 alert(ADD_KRISHAK_SCREEN.KRISHAK_ALREADY_EXIST);
        //                 Utilities.LogPrint("getKrishakByReferenceId", response);
        //                 this.props.history.push({
        //                     pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
        //                     state: { krishakInfo: response.data }
        //                 });
        //             }
        //             else {
        //                 this.props.history.push({
        //                     pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
        //                     state: { mobileNumber: this.state.mobileNumber }
        //                 });
        //             }
        //         })
        //         .catch(error => {
        //             Utilities.LogPrint("getKrishakByReferenceId-catch", error);
        //         });
        // }
        // catch (error) {
        //     Utilities.LogPrint("getKrishakByReferenceId-error", error);
        // }

    }

    goToKrishakPage = (krishakInfo) => {
        this.props.history.push({
            pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
            state: { krishakInfo: krishakInfo }
        });
    }

    getKrishakById = (krishakId) => {
        //this.setState({ isLoading: true });
        var body = JSON.stringify({
            krishak_id: krishakId,
            phone: this.state.mobileNumber,
        });
        try {
            ApiServices.getKrishakByReferenceId(body).then(response => {
                var status = response.success;
                if (status) {
                    //this.setState({ isLoading: false });
                    const krishakInfo = response.data;
                    if (krishakInfo != null) {
                        this.goToKrishakPage(krishakInfo);
                    }
                }
            }).catch(error => {
                Utilities.LogPrint("getKrishakById", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    _handleMoreMenuClick = () => {
        this.props.history.push(ALL_ROUTES.MORE_MENU_ROUTE);
    }

    render() {
        const { isDashboardActive, isTodayActive, isCalendarActive, isKrishakActive, isMoreMenuActive, mobileNumber } = this.state;
        const enabledGo = (mobileNumber.length === 10);

        const showDashboard = AuthService.getRoleAccess(PERMISSION_CONSTANTS.DASHBOARD_VIEW);
        const showHomeToday = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_INDIVIDUAL_VISIT);
        const showCalendar = AuthService.getRoleAccess(PERMISSION_CONSTANTS.CALENDAR);
        const showKrishak = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_KRISHAK);


        return (
            <div id="header">
                <section className="bottom-navbar d-block d-lg-none">
                    <ul className="d-flex nav">
                        <li className={`bottom-nav-item text-center ${showDashboard?.view ? '' : 'd-none'}`}>
                            <a className={isDashboardActive ? "navlink active" : "navlink"} onClick={this._handleDashboardClick}>
                                <i className="customic ic-dashboard"></i>
                                <span className="d-block">{COMMON.DASHBOARD}</span>
                            </a>
                        </li>
                        <li className={`bottom-nav-item text-center ${showCalendar?.view ? '' : 'd-none'}`}>
                            <a className={isCalendarActive ? "navlink active" : "navlink"} onClick={this._handleCalendarClick}>
                                <i className="customic ic-calendar"></i>
                                <span className="d-block">{COMMON.CALENDER}</span>
                            </a>
                        </li>
                        <li className={`bottom-nav-item text-center ${showHomeToday?.view ? '' : 'd-none'}`}>
                            <a className={isTodayActive ? "navlink active" : "navlink"} onClick={this._handleTodayClick}>
                                <i className="customic ic-today"></i>
                                <span className="d-block">{COMMON.TODAY}</span>
                            </a>
                        </li>
                        <li className={`bottom-nav-item text-center ${showKrishak?.view ? '' : 'd-none'}`}>
                            <a className={isKrishakActive ? "navlink active" : "navlink"} data-toggle="modal" data-target="#farmerMobileModal">
                                <i className="customic ic-krishak"></i>
                                <span className="d-block">{COMMON.KRISHAK}</span>
                            </a>
                        </li>
                        <li className="bottom-nav-item text-center">
                            <a className={isMoreMenuActive ? "navlink active" : "navlink"} onClick={this._handleMoreMenuClick}>
                                <i className="customic ic-more"></i>
                                <span className="d-block">{COMMON.MORE}</span>
                            </a>
                        </li>
                    </ul>
                </section>
                {/* MOBILE NUMBER POPUP */}
                <div className="modal fade bottom-drawer" id="farmerMobileModal" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER}</h6>
                                <form action="">
                                    <div className="form-group mobile-number-input">
                                        <label>+91 -</label>
                                        <input type="text" className="form-control" placeholder="" maxLength="10" />
                                    </div>
                                    <button className="btn btn-primary w-100 mb-2"
                                        onClick={this._handleKrishakClick}
                                        data-dismiss="modal"
                                        disabled={!enabledGo}
                                    >{HOME_TODAY_SCREEN.GO}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default withRouter(Footer)
